import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/FamilyIllustration.tsx
const FamilyIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "family.svg",
		alt: t("illustration.imageAlt.family")
	});
};

//#endregion
export { FamilyIllustration };